import React from 'react';
import TimerInputController from './controllers/TimerInputController';
import styles from './Timer.module.css';
import {
  ApplicationView,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';

const TimerInput: React.FC = () => {
  const inputController = useController(TimerInputController);
  const inputText = inputController.state.inputText;

  return (
    <>
      <div className={styles.inactiveControls}>
        <div
          className={styles.sideButton}
          onClick={() => inputController.actionIncrementDuration(false)}
        >
          -
        </div>
        <input
          id={styles.timerInput}
          type={'text'}
          size={12}
          value={inputText}
          onChange={event => {
            inputController.actionSetInputText(event.target.value);
          }}
          onBlur={event => {
            inputController.actionUpdateFromInput(event.currentTarget.value);
          }}
        />
        <div
          className={styles.sideButton}
          onClick={() => inputController.actionIncrementDuration(true)}
        >
          +
        </div>
      </div>

      <aha-button
        kind={'primary'}
        onClick={() => inputController.actionStartTimer()}
      >
        Start timer
      </aha-button>
    </>
  );
};

const ControlledTimerInput = StartControllerScope(
  TimerInputController,
  ApplicationView(TimerInput)
);

export default ControlledTimerInput;
